package com.anjuros.website.templates.template2.sections

import androidx.compose.runtime.Composable
import com.anjuros.website.components.shared.AnjurosCopyright
import com.anjuros.website.components.shared.AnjurosLogo
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.template2.styles.CompanyColorVar
import com.anjuros.website.templates.template2.modules.Template2Section
import com.anjuros.website.templates.template2.modules.Template2Theme
import com.anjuros.website.templates.template2.modules.getColor
import com.anjuros.website.templates.template2.styles.Template2FooterMarginStyle
import com.anjuros.website.templates.template2.styles.Template2NavigationItemStyle
import com.anjuros.website.templates.template2.util.Template2CompanyDetails
import com.anjuros.website.templates.template2.util.Template2Constants
import com.anjuros.website.templates.template2.util.Template2Constants.CLIENTS_EMAIL
import com.anjuros.website.templates.template2.util.Template2Constants.FONT_FAMILY
import com.anjuros.website.templates.template2.util.Template2Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun  Template2FooterSection(){


    Box(modifier = Modifier
        .fillMaxWidth()
        .padding(topBottom = 10.px)
        .backgroundColor(Template2Theme.DarkGrey.rgb),
        contentAlignment = Alignment.Center) {


        Template2FooterContent()
    }
}

@Composable
private fun Template2FooterContent(){

    SimpleGrid(numColumns = numColumns(base=1,md=3),
        modifier = Modifier.fillMaxSize()){
        FooterMenu()
        FooterLogo()
        FooterContact()
    }
}

@Composable
fun  FooterMenu(){
    val color = Template2Theme.Primary.getColor()

    Box(modifier = Modifier.fillMaxHeight()) {
        Column(
            modifier = Modifier.align(Alignment.Center),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            Template2Section.entries.toTypedArray().forEach { section ->
                Link(
                    modifier = Modifier
                        .padding(
                            right = 0.px,
                            bottom = if(section.ordinal<Template2Section.entries.size-1) 20.px else 0.px
                        )
                        .textDecorationLine(TextDecorationLine.None),
                    path = section.path
                ) {


                    Column(modifier = Template2NavigationItemStyle.toModifier()) {
                        Link(
                            modifier = Modifier
                                .align(Alignment.CenterHorizontally)
                                .textDecorationLine(TextDecorationLine.None),
                            path = section.path
                        ) {
                            P(
                                attrs = Modifier
                                    .margin(topBottom = 0.px)
                                    .fontFamily(Template2Constants.FONT_FAMILY)
                                    .fontSize(18.px)
                                    .color(Colors.White)
                                    .fontWeight(FontWeight.Normal)
                                    .toAttrs()
                            ) {
                                Text(LocalText(section.headerTitle))

                            }
                        }

                        Box(modifier = Modifier.id("sectionUnderline").align(Alignment.CenterHorizontally).padding(right = 30.px).width(40.px).height(2.px).backgroundColor(Colors.White))
                    }
                }

            }
        }
    }

}

@Composable
fun FooterLogo(){

    Box(
        modifier = Template2FooterMarginStyle.toModifier().fillMaxWidth()
    ) {
        Box(
            modifier = Modifier.fillMaxHeight().displayIfAtLeast(Breakpoint.MD).width(3.px).backgroundColor(Colors.White)
                .align(Alignment.CenterStart)
        )
        Box(
            modifier = Modifier.fillMaxHeight().displayIfAtLeast(Breakpoint.MD).width(3.px).backgroundColor(Colors.White)
                .align(Alignment.CenterEnd)
        )

        Box(
            modifier = Modifier
                .align(Alignment.Center)
                .margin(bottom = 20.px)
        ) {
            Row(
                horizontalArrangement = Arrangement.spacedBy(20.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Link(
                    modifier = Modifier
                        .textDecorationLine(TextDecorationLine.None),
                    path = "#home"
                ) {
                    AnjurosLogo(
                        modifier = Modifier.size(120.px, 100.px),
                        src = Template2Res.Image.template2_logo2,
                        alt = "Professional website design for UK sole traders"
                    )
                }

                CompanyDetails(
                    modifier = Modifier
                )
            }
        }

        Box(modifier = Modifier.displayIfAtLeast(Breakpoint.MD).align(Alignment.BottomCenter)) {
            AnjurosCopyright(Modifier.align(Alignment.BottomCenter))
        }
    }

}


@Composable
fun FooterContact(){

    Box(modifier = Modifier.fillMaxHeight()) {
        Column(
            modifier = Modifier.align(Alignment.Center),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Link(
                modifier = Modifier
                    .margin(bottom = 10.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(20.px)
                    .fontWeight(FontWeight.Normal)
                    .color(Colors.White)
                    .textDecorationLine(TextDecorationLine.None),
                path = "tel:${Template2Constants.CLIENTS_PHONE}"
            ) {
                AnjurosText(Template2CompanyDetails.CLIENTS_PHONE_INFO)
            }
            Link(
                modifier = Modifier
                    .margin(top = 10.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(20.px)
                    .fontWeight(FontWeight.Normal)
                    .color(Colors.White)
                    .textDecorationLine(TextDecorationLine.None),
                path = "mailto:$CLIENTS_EMAIL"
            ) {
                AnjurosText(Template2CompanyDetails.CLIENTS_EMAIL_INFO)
            }
            Box(modifier = Modifier.displayUntil(Breakpoint.MD).margin(top=5.px)) {
                AnjurosCopyright(Modifier.align(Alignment.BottomCenter))
            }

        }

    }
}

@Composable
fun CompanyDetails(modifier: Modifier){

    Column(modifier = modifier){
        P(
            attrs = Modifier

                .margin(topBottom = 0.px)
                .fontFamily(FONT_FAMILY)
                .fontSize(14.px)
                .color(Colors.White)
                .fontWeight(FontWeight.Normal)
                .toAttrs()
        ) {
            AnjurosText(Template2CompanyDetails.CLIENTS_NAME_INFO)
        }
        P(
            attrs = Modifier

                .margin(topBottom = 0.px)
                .fontFamily(FONT_FAMILY)
                .fontSize(14.px)
                .color(Colors.White)
                .fontWeight(FontWeight.Normal)
                .toAttrs()
        ) {
            AnjurosText(Template2CompanyDetails.CLIENTS_COMPANY_NUMBER_INFO)
        }
        P(
            attrs = Modifier

                .margin(topBottom = 0.px)
                .fontFamily(FONT_FAMILY)
                .fontSize(14.px)
                .color(Colors.White)
                .fontWeight(FontWeight.Normal)
                .toAttrs()
        ) {
            AnjurosText(Template2CompanyDetails.CLIENTS_COMPANY_ADDRESS1_INFO)
        }
        P(
            attrs = Modifier

                .margin(topBottom = 0.px)
                .fontFamily(FONT_FAMILY)
                .fontSize(14.px)
                .color(Colors.White)
                .fontWeight(FontWeight.Normal)
                .toAttrs()
        ) {
            AnjurosText(Template2CompanyDetails.CLIENTS_COMPANY_ADDRESS2_INFO)
        }
    }
}